import script from "./materialInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./materialInventory.vue?vue&type=script&setup=true&lang=js"

import "./materialInventory.vue?vue&type=style&index=0&id=ab477370&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab477370"]])

export default __exports__